import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../shared';
import { SidebarMenuComponent } from './sidebar-menu.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
  ],
  declarations: [
    SidebarMenuComponent
  ],
  exports: [SidebarMenuComponent],
})
export class SidebarMenuModule {}
